import React, { useEffect } from "react";
import _ from "lodash";
import Socket from "socket";
import { motion } from "framer-motion/dist/framer-motion";

import lightningTrivia from "assets/images/sbs/lightningTrivia.png";
import TriviaSubmit from "assets/images/sbs/TriviaSubmit.png";

const BeforeAnswerSubmit = ({
  roomObj,
  sound_in,
  playAudio,
  countdown,
  transition,
  mobile_app,
  questionObj,
  lts = false,
  lt_question,
  currentPlayer,
  top_logo_mobile,
  set_lt_question,
  question_params,
  set_lt_countdown,
  set_has_answered
}) => {
  const timed_text = _.get(
    question_params,
    "timed_text",
    "Quick! You're being timed!"
  );

  let timer;

  useEffect(() => {
    return () => playAudio(sound_in);
  }, []);

  useEffect(() => {
    timer = setInterval(() => set_lt_countdown(countdown + 1), 1000);
    return () => clearInterval(timer);
  }, [countdown]);

  useEffect(() => {
    if (lt_question !== questionObj?.question) {
      if (mobile_app) {
        const message = {
          action: "vibrate"
        };
        window.parent.postMessage(message, "*");
      } else {
        const canVibrate = window.navigator.vibrate;
        if (canVibrate) window.navigator.vibrate(500);
      }
      set_lt_question(questionObj?.question);
      set_lt_countdown(0);
    }
  }, [questionObj?.question]);

  const onAnswerClick = (index) => {
    set_has_answered(true);
    playAudio(transition);
    clearInterval(timer);
    if (mobile_app) {
      const message = {
        action: "lt-submit-answer",
        answer: index,
        answer_time: countdown
      };
      window.parent.postMessage(message, "*");
    } else {
      const data = {
        action: "lt-submit-answer",
        roomId: roomObj.id,
        playerId: currentPlayer.player_id,
        answer: index,
        answer_time: countdown
      };
      Socket.sendMessage(data);
    }
  };
  const divVariants = {
    hidden: {},
    visible: {},
    exit: {}
  };
  const scrollDivVariants = {
    hidden: { x: "100vw" },
    visible: { x: 0 },
    exit: { x: "-100vw", transition: { delay: 0.4 } }
  };
  const buttonVariants = {
    hidden: { x: "100vw" },
    visible: { x: 0 },
    exit: { x: "-100vw" }
  };
  const textVariants = {
    hidden: { opacity: 0.4, scale: 0.2 },
    visible: { opacity: 1, scale: 1 },
    exit: { opacity: 0, scale: 0.2 }
  };
  const imgVariants = {
    hidden: {
      y: "-100vh",
      opacity: 0.5,
      scale: 0.7
    },
    visible: {
      y: 0,
      opacity: 1,
      scale: 1,
      transition: {
        type: "tween",
        duration: 0.2,
        opacity: { delay: 0.2, duration: 0.3 },
        scale: { delay: 0.2, duration: 0.3 }
      }
    }
  };

  return (
    <div
      className={`container Lightning-trivia ${
        top_logo_mobile ? "global" : ""
      }`}
    >
      <motion.div
        variants={divVariants}
        initial="hidden"
        animate="visible"
        exit="exit"
        className="Lightning-trivia-Wrapper"
      >
        <motion.img
          variants={lts ? {} : imgVariants}
          src={
            lts
              ? TriviaSubmit
              : top_logo_mobile
              ? top_logo_mobile
              : lightningTrivia
          }
          className="logoimage"
          alt="sbsLogo"
        />
        <motion.div
          variants={scrollDivVariants}
          className={`${
            mobile_app ? "overflowQuestionDivMobile " : "overflowQuestionDiv"
          }`}
        >
          <motion.div
            variants={buttonVariants}
            id="quesDiv"
            className="sbs-trivia-title"
          >
            <h2 className="mediamText darkBlueText">{questionObj?.question}</h2>
          </motion.div>
          {questionObj?.answers.map(
            (answer, index) =>
              answer !== "" && (
                <motion.button
                  key={index}
                  type="submit"
                  variants={buttonVariants}
                  className="sbsButton answerBtn"
                  onClick={() => onAnswerClick(index)}
                  transition={{ delay: (index + 1) / 10 }}
                >
                  {answer}
                </motion.button>
              )
          )}
        </motion.div>
        <motion.h2
          variants={textVariants}
          className="mediamText blueText timedText"
        >
          {timed_text}
        </motion.h2>
        <motion.h1
          variants={textVariants}
          className="largeText whiteText countdownText"
        >
          {countdown} Seconds
        </motion.h1>
      </motion.div>
    </div>
  );
};

export default BeforeAnswerSubmit;
